const DEFAULT_BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.bosscarnetwork.com/api/v1"
    : "http://localhost:8080/api/v1";

const normalizeBaseUrl = (url?: string): string =>
  (url || DEFAULT_BASE_URL).replace(/\/+$/, "");

export const BASE_URL = normalizeBaseUrl(process.env.REACT_APP_BASE_URL);

export const Requests = {
  get: {
    getLiveCars: "/cars/active/livecars",
    getCar: "/cars/:id",
    getAdminCar: "/cars/admin/:id",
    getCarByTag: "/cars/tag/:tag",
    getCars: "/cars",
    getUserCars: "/cars/user/:id",
    getAgents: "/users/staff/agents",
    getStaff: "/users/staff/personnel",
    getUser: "/users/:id",
    getUsers: "/users",
    getReports: "/report",
    getClicks: "/carClick",
    getConversations: "/conversations",
    getConversation: "/conversations/conversation/:id",
    getMessages: "/messages/:id",
    getTodayStat: "/stat/today",
    getTotalStat: "/stat",
    getMoneyRequests: "/moneyRequest",
    getMoneyRequest: "/moneyRequest/:id",
    getUserMoneyRequests: "/moneyRequest/user/:id",
    getCarRequests: "/request",
    getNotifications: "/notifications",
    getNotificationsUnreadCount: "/notifications/unread-count",
    getSetting: "/setting",
    getCarMakes: "/car-makes",
    getImporterModels: "/importer-models",
    getAdminImporterModels: "/importer-models/admin",
    getMasterProfiles: "/master-profiles",
    getAdminMasterProfiles: "/master-profiles/admin",
    getPublicDealerInventory: "/dealer-inventory",
    getDealers: "/admin/dealers",
    getDealerMembers: "/admin/dealer-members",
    getAdminDealerInventory: "/admin/dealer-inventory",
    getDealerLeads: "/admin/dealer-leads",
    getDealerInventory: "/dealer/inventory",
    getDealerSubmissions: "/dealer/submissions",
    getPortalDealerAccounts: "/dealer/auth/accounts",
    getAdminDealerSubmissions: "/admin/dealer-submissions",
    getAdminImporterPrices: "/admin/importer-prices",
    getSparePartCategories: "/spare-parts/categories",
    getSparePartProducts: "/spare-parts/products",
    getSparePartRequests: "/spare-parts/admin/requests",
    getVideos: "/admin/videos",
    getCaptureDrafts: "/admin/capture-drafts",
    getCaptureDraft: "/admin/capture-drafts/:id",
    getCarInspection: "/cars/:id/inspection",
    getExternalCarSource: "/admin/external-imports/cars/:id/source",
    getGariImportJob: "/admin/external-imports/gari/jobs/:id",
    getFacebookImportJob: "/admin/external-imports/facebook/jobs/:id",
    getValuations: "/valuations/admin",
    getValuationObservations: "/valuations/admin/observations",
    getValuationPriceTrend: "/valuations/admin/price-trend",
    getCanonicalVehicleModels: "/valuations/admin/models",
    getValuationCalibration: "/valuations/admin/calibration",
    getDistributionCars: "/admin/distributions/cars",
  },
  post: {
    sendMessage: "/messages/:id",
    sendDirectMessage: "/messages/customer/:customerId",
    login: "/auth/login",
    registerStaff: "/auth/register",
    suspendUser: "/report/suspendPostingPrivileges",
    unSuspendUser: "/report/unSuspendPostingPrivileges",
    broadcastNotification: "/notifications/broadcast",
    loginDealer: "/dealer/auth/login",
    createDealer: "/admin/dealers",
    createDealerMember: "/admin/dealer-members",
    createImporterModel: "/importer-models",
    createMasterProfile: "/master-profiles",
    createDealerInventory: "/dealer/inventory",
    createDealerSubmission: "/dealer/submissions",
    uploadDealerSubmissionPhoto: "/dealer/submissions/:id/photos",
    publishOwnDealerSubmission: "/dealer/submissions/:id/publish",
    publishDealerSubmission: "/admin/dealer-submissions/:id/publish",
    clickDealerInventory: "/dealer-inventory/:id/click",
    createSparePartCategory: "/spare-parts/admin/categories",
    createSparePartProduct: "/spare-parts/admin/products",
    createVideo: "/admin/videos",
    createCaptureDraft: "/admin/capture-drafts",
    uploadCaptureDraftImage: "/admin/capture-drafts/:id/images",
    publishCaptureDraft: "/admin/capture-drafts/:id/publish",
    retryCaptureTelegram: "/admin/capture-drafts/:id/telegram/retry",
    quickCreateDealer: "/admin/dealers/quick",
    previewMekinaImport: "/admin/external-imports/mekina/preview",
    publishMekinaImport: "/admin/external-imports/mekina/publish",
    previewGariImport: "/admin/external-imports/gari/preview",
    publishGariImport: "/admin/external-imports/gari/publish",
    previewFacebookImport: "/admin/external-imports/facebook/preview",
    createFacebookImportJob: "/admin/external-imports/facebook/jobs",
    publishFacebookImport: "/admin/external-imports/facebook/publish",
    createValuationObservation: "/valuations/admin/observations",
    previewJijiValuationObservation:
      "/valuations/admin/observations/jiji/preview",
    collectJijiValuationObservations:
      "/valuations/admin/observations/jiji/collect",
    importValuationObservations: "/valuations/admin/observations/import",
    prepareDistribution: "/admin/distributions/prepare",
  },
  update: {
    updateCar: "/cars/:id",
    repostCar: "/cars/:id/repost",
    updateUser: "/users/:id",
    updateUserType: "/users/usertype/:id",
    updateMoneyRequest: "/moneyRequest/:id",
    readConversation: "/conversations/:id/read",
    markNotificationRead: "/notifications/:id/read",
    markAllNotificationsRead: "/notifications/read-all",
    updateAppUpdatePolicy: "/setting/app-update",
    updateDealer: "/admin/dealers/:id",
    updateDealerMember: "/admin/dealer-members/:id",
    updateImporterModel: "/importer-models/:id",
    updateMasterProfile: "/master-profiles/:id",
    updateAdminDealerInventory: "/admin/dealer-inventory/:id",
    updateDealerLead: "/admin/dealer-leads/:id",
    updateDealerInventory: "/dealer/inventory/:id",
    updateDealerSubmission: "/dealer/submissions/:id",
    updateAdminDealerSubmission: "/admin/dealer-submissions/:id",
    updateAdminImporterPrice: "/admin/importer-prices/:id",
    confirmDealerInventory: "/dealer/inventory/:id/confirm",
    updateSparePartRequest: "/spare-parts/admin/requests/:id",
    updateSparePartProduct: "/spare-parts/admin/products/:id",
    updateVideo: "/admin/videos/:id",
    updateCaptureDraft: "/admin/capture-drafts/:id",
    replaceCaptureDraftImage: "/admin/capture-drafts/:id/images/:imageId",
    updateCarInspection: "/cars/:id/inspection",
    reviewValuation: "/valuations/admin/:id/review",
    recordValuationOutcome: "/valuations/admin/:id/outcome",
    resolveCanonicalVehicleModel: "/valuations/admin/models/:id/resolve",
    updateDistribution: "/admin/distributions/:id",
  },
  delete: {
    deleteCar: "/cars/:id",
    deleteMessage: "/messages/:id",
    deleteDealerInventory: "/dealer/inventory/:id",
    deleteDealerMember: "/admin/dealer-members/:id",
    deleteDealerSubmission: "/dealer/submissions/:id",
    deleteDealerSubmissionPhoto: "/dealer/submissions/:id/photos/:imageId",
    deleteVideo: "/admin/videos/:id",
    deleteCaptureDraft: "/admin/capture-drafts/:id",
    deleteCaptureDraftImage: "/admin/capture-drafts/:id/images/:imageId",
  },
};

export const Sort = {
  descendingOrder: "orders:desc",
  ascendingOrder: "orders:asc",
  descendingCreatedAtOrder: "createdAt:desc",
  ascendingCreatedAtOrder: "createdAt:asc",
};
